<template>
  <Padding :padding>
    <ImageAtom
      v-if="imageAtom"
      v-bind="imageAtom"
    />
  </Padding>
</template>

<script lang="ts" setup>
import ImageAtom from './ImageAtom.vue';
import Padding from '~/components/Atmos/Padding/Padding.vue';
import type { PortableTextImage } from '~/sanity/types';
defineProps<PortableTextImage>();
</script>
<style></style>
